const emptyClosure = () => {};

class CallbackChain
{
    /**
     * Mit einer Instanz dieser CallbackChain lassen sich sehr einfach Callback-Funktionen aneinanderreihen,
     * um ein Verschachtelun zu verhindern.
     */
    constructor()
    {
        this._closures = [];
    }

    /** Dieser Getter gibt immer eine Funktion zurück. Entweder die nächste in der Chain oder eine Leerfunktion.
     * @param {Function}
     */
    get next()
    {
        return this._closures.shift() || emptyClosure;
    }

    /** Leert die Chain und führt somit dazu, dass kein Callback mehr ausgeführt wird. */
    clear()
    {
        this._closures.length = 0;
    }

    /** Fügt eine oder mehrere Funktionen zur Chain hinzu
     * @param {...Function} closures
     * @return {this}
     */
    add(...closures)
    {
        const {length} = closures;
        for (let i = 0; i < length; i++)
        {
            if (typeof closures[i] === 'function')
            {
                this._closures.push(closures[i]);
                continue;
            }
        }
        return this;
    }
}

export default CallbackChain;
